module.exports = __webpack_public_path__ + "media/printed-materials/educators-01-marketing-poster-a5e774de.png";